import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tr-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './spinner.component.html',
  //styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() spin: boolean = false;
  @Input() progress: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/spinner/spinner.component.ts